/**
 * Returns the difference between initially set date which is Jul 1 2018 = 1530428400000
 * and returns the updated date object based on current date; 
 * @param {Number} currentDate current date
 * @param {Number} prevDate previous date
 */

 //To test, change the new Date(1561964400000) = Fri Jun 31 2019 

export default function getSchoolYear(currentDate = new Date(), prevDate = 1530428400000) {

    const date = Math.abs(currentDate - new Date(prevDate)) / 1000;
    const dateDiff = Math.floor(date / 31536000);

    if(dateDiff) {
        let newDate = new Date(prevDate);
        let newTimeStamp = newDate.setFullYear(newDate.getFullYear() + dateDiff);

        return {
            year: `sy${newDate.getFullYear()}`,
            timeStamp: newTimeStamp,
            date: `${newDate.toDateString() +'-'+ Number(newDate.getFullYear() + 1)}`
        }
    } else {
        prevDate = new Date(prevDate);
        return {
            year: `sy${prevDate.getFullYear()}`, 
            timeStamp: prevDate.getTime(), 
            date: `${prevDate.toDateString() +'-'+ Number(prevDate.getFullYear() + 1)}`
        };
    }
   
}


// WEBPACK FOOTER //
// ./src/helpers/getSchoolYear.js